import React, { useContext } from 'react';
import { formatDate } from '../../../lib/utils/utils';
import AddBlack from "../../../Assets/PlusIcon/AddBlack.svg";
import RedDelete from "../../../Assets/redDelete.svg";
import { useDispatch } from 'react-redux';
import { setModal } from '../../../Features/couponsSlice';
import { AddCouponFormContext } from '../../../Context/Coupons/AddCouponFormContext';

function AddDuration() {
    const dispatch = useDispatch();

    const { date, setDate, formErrors } = useContext(AddCouponFormContext);

    const handleAddDuration = () => {
        dispatch(setModal('select-duration'));
    }

    return (
        <div className="border border-[#EAEAEA] bg-[#FFFFFF] p-5 rounded-xl flex flex-col gap-6">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <h1 className='font-semibold text-[#121212] text-[18px] leading-6'>Duration</h1>

                    <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.date}</p>
                </div>

                <button onClick={handleAddDuration} className='flex items-center gap-1 font-semibold text-base text-primaryColor'>
                    <div className="size-6 flex items-center justify-center">
                        <img src={AddBlack} alt="" />
                    </div>

                    Set Duration
                </button>
            </div>

            {
                (date.from && date.to) ? 
                <div className="border border-[#EAEAEA] rounded-lg overflow-hidden flex flex-col">
                    <div className="px-[10px] py-2 bg-[#F5F5F5] flex items-center">
                        <p className='text-base font-semibold text-[#121212] select-none w-[calc((100%-44px)/2)]'>Start Date</p>

                        <p className='text-base font-semibold text-[#121212] select-none w-[calc((100%-44px)/2)]'>End Date</p>
                                
                        <div className="w-11"></div>
                    </div>

                    <div className="flex items-center px-[10px] py-2 font-medium text-[14px] leading-6 text-[#121212]">
                        <p className="w-[calc((100%-44px)/2)]">{formatDate(date.from)} &#40;UTC&#41;</p>

                        <p className="w-[calc((100%-44px)/2)]">{formatDate(date.to)} &#40;UTC&#41;</p>

                        <button onClick={() => { setDate({ from: null, to: null }) }} className="w-11 h-[42px] outline-none px-[5px] py-[6px]">
                            <div className="size-8 flex items-center justify-center">
                                <img src={RedDelete} alt="" />
                            </div>
                        </button>
                    </div>
                </div> : 
                <div className="flex flex-col items-center gap-2 text-[#666666] leading-7">
                    <h1 className='font-semibold text-[18px]'>No duration are added yet</h1>

                    <p className='font-medium text-[16px] text-center'>This feature allows you to define the time period during which this Coupon will be visible within this category in the store.</p>
                </div>
            }
        </div>
    );
}

export default AddDuration;
